<div class="label">
    <div class="label-title" id="label">
        {{ name | translate }}
    </div>
</div>
<dd class="value">
    <div class="value-title" id="value">
        {{ value }}
    </div>
</dd>
